// Client-side PDF text extraction with pdf.js (CDN worker)
import * as pdfjsLib from "pdfjs-dist/build/pdf";

// Use CDN worker matching installed version
const PDFJS_VERSION = "4.8.69";
pdfjsLib.GlobalWorkerOptions.workerSrc =
  `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${PDFJS_VERSION}/pdf.worker.min.mjs`;

export async function extractPdfText(file) {
  const buf = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: buf }).promise;
  const pages = [];
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i);
    const tc = await page.getTextContent();
    const text = tc.items.map((it) => it.str).join(" ");
    pages.push(`--- Página ${i} ---\n${text}`);
  }
  return pages.join("\n\n");
}
